const SDK_VERSION = '7.59.3';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
